import * as React from 'react';
import S from './HorizontalForm.styles';
const HorizontalFormSection = ({ align, children, inputId, title, }) => {
    return (React.createElement(S.Section, { "data-align": align },
        title && React.createElement(S.Label, { htmlFor: inputId }, title),
        React.createElement(S.Inner, null, children)));
};
export default HorizontalFormSection;
